var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFantomeChute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 963.98 872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#ffd93b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fantome chute") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_8",
    "data-name": "Calque 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1437.45,1377H520.25c-17.52,0-28.53-19.42-19.88-35.08l455.09-824a22.56,22.56,0,0,1,39.69-.14l462.1,824C1466,1357.45,1455,1377,1437.45,1377Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1346.57,1324.5H603.13c-14.2,0-23.13-15.74-16.12-28.43L955.89,628.14a18.29,18.29,0,0,1,32.17-.11L1362.63,1296C1369.74,1308.65,1360.83,1324.5,1346.57,1324.5Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.14 784.5 300.14 784.5 301 691.5 215.14 691.5 215.14 668.5 323.14 668.5 323.14 784.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784,1127l94-43c4.7-2.26,10.17-3,16-3l72,8c10,1,15.4-1.88,18-7l35-82-65-48c-4.75-3.8-8.6-8.51-12.4-15.83q-.3-.57-.6-1.17l-29-69c-4-13,19-26,26-13l34,66a22.44,22.44,0,0,0,7,10l62,42,60,26,68,53,27,87c3,18-25,25-33,5l-17-62c-3-9-6-12-12-16l-42-29-45,94a52.09,52.09,0,0,1-23,22l-66,36-18,16-58,64c-11,14-40-5-29-20l63-77c9-10.35,19.41-18.45,32-23l28-13-83-12-97,37C777,1165,764,1136,784,1127Z",
    transform: "translate(-496.86 -505.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 590.14,
    cy: 438.5,
    r: 34
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantomeChute);
export default __webpack_public_path__ + "static/media/fantome_chute.3f324288f7e6971ac7ad8be122f9fc3f.svg";
export { ForwardRef as ReactComponent };